/**
 * Avalara © 2017
 * file: engines/opus_ui/src/AvataxCard.js
 */

import React, { Component } from 'react';
import Users from './Users';
import Services from './Services';
import './AvataxCard.css';
import { Link } from 'react-router-dom';
import { getLink } from '../../search/CustomerCard';

class AvataxCard extends Component {
  render() {
    const { deliveryInfo } = this.props;
    // AvaTax search results always carry the CRM id/name under details,
    // so fall back to those when customerAccount isn't populated on the response.
    const customerAccountId = deliveryInfo.customerAccount
      ? deliveryInfo.customerAccount.id
      : deliveryInfo.details
      ? deliveryInfo.details.crmid
      : undefined;
    const customerAccountName = deliveryInfo.customerAccount
      ? deliveryInfo.customerAccount.name
      : deliveryInfo.details
      ? deliveryInfo.details.name
      : undefined;
    const customerCardLink = getLink({
      id: customerAccountId || deliveryInfo.id,
    });

    return (
      <table>
        <tbody className='avatax_card_tbody'>
          <tr>
            <td>Customer Account Id</td>
            <td>
              <Link className="Link" to={customerCardLink}>
                {customerAccountId || 'No customer found'}
              </Link>
            </td>
          </tr>
          <tr>
            <td>Customer Account Name</td>
            <td>
              {customerAccountName || 'No customer found'}
            </td>
          </tr>
          <tr>
            <td>Name</td>
            <td>{deliveryInfo.details ? deliveryInfo.details.name : 'N/A'}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              {deliveryInfo.details
                ? deliveryInfo.details.accountStatusId
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Account Type</td>
            <td>
              {deliveryInfo.details
                ? deliveryInfo.details.accountTypeId
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Created Date</td>
            <td>
              {new Date(
                deliveryInfo.details ? deliveryInfo.details.createdDate : 'N/A'
              ).toLocaleDateString()}
            </td>
          </tr>
          <tr>
            <td>Created User Id</td>
            <td>
              {deliveryInfo.details
                ? deliveryInfo.details.createdUserId
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Modified Date</td>
            <td>
              {new Date(
                deliveryInfo.details ? deliveryInfo.details.modifiedDate : 'N/A'
              ).toLocaleDateString()}
            </td>
          </tr>
          <tr>
            <td>Modified User Id</td>
            <td>
              {deliveryInfo.details
                ? deliveryInfo.details.modifiedUserId
                : 'N/A'}
            </td>
          </tr>
          <tr>
            <td>Effective From</td>
            <td>
              {new Date(
                deliveryInfo.details
                  ? deliveryInfo.details.effectiveDate
                  : 'N/A'
              ).toLocaleDateString()}
            </td>
          </tr>
          {deliveryInfo.details ? (
            deliveryInfo.details.endDate ? (
              <tr>
                <td>Effective To</td>
                <td>
                  {new Date(deliveryInfo.details.endDate).toLocaleDateString()}
                </td>
              </tr>
            ) : undefined
          ) : undefined}
          <tr>
            <td>Users</td>
            <Users
              name="Users"
              data={deliveryInfo.details ? deliveryInfo.details.users : []}
            />
          </tr>
          <tr>
            <td>Services</td>
            <Services
              name="Services"
              data={
                deliveryInfo.details ? deliveryInfo.details.subscriptions : []
              }
            />
          </tr>
        </tbody>
      </table>
    );
  }
}

export default AvataxCard;
